import { compose, mount, route } from 'navi';
import { FiltersProvider } from 'pages/search/filters/filters-context';
import { SearchProvider } from 'pages/search/search-context';
import { ResultsProvider } from 'pages/shared/results-context';
import React from 'react';
import { Info } from '../search/info/info';
import { AnimalDetails } from './animal-details';
import CompareAnimals from './compare-animals';

export default compose(
  mount({
    '/:id': route((req) => {
      const {
        id, db, scenario, asbvs,
      } = req.params;
      return {
        view: (
          <>
            <Info />
            <AnimalDetails
              id={id}
              db={parseInt(db)}
              subIndex={parseInt(scenario)}
              asbvs={asbvs}
            />
          </>
        ),
      };
    }),
    '/compare-animals': route((req) => {
      const {
        animals, db, scenario,
      } = req.params;
      return {
        view: (
          <>
            <SearchProvider>
              <FiltersProvider>
                <ResultsProvider>
                  <Info />
                  <CompareAnimals
                    animals={animals}
                    db={parseInt(db)}
                    subIndex={parseInt(scenario)}
                  />
                </ResultsProvider>
              </FiltersProvider>
            </SearchProvider>,
          </>
        ),
      };
    }),
  }),
);
